<div *ngIf="!selectionMade">
  <div #container class="container">
    <div *ngFor="let f of folderDisplays; index as i" class="folder">
      <div #folderDom class="hide">
        <img
          (load)="fadeIn(i)"
          (click)="selectFolder(f.name, $event)"
          src="{{ f.path }}"
          alt="Shannon Schultz Photo"
          class="item"
        />
        <div class="title">
          <h5>{{ f.name }}</h5>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="selectionMade">
  <div *ngIf="!mobile">
    <app-top-nav #desktop [folders]="folders"></app-top-nav>
  </div>
  <div *ngIf="mobile">
    <app-mobile-nav [folders]="folders"></app-mobile-nav>
  </div>
</div>
